<div class="container-fluid pt-5 pb-3">
    <div class="container-xxxl bg-white">
        <div class="row">
            <div class="col">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-maroon border-maroon">{{ textHeader }}</h2>
                    </div>
                </div>

                <h3 class="fs-5 fs-md-22 fw-500 lh-sm text-maroon">
                    {{ medTeam?.title }}
                </h3>

                <div class="mt-3"></div>

                <p class="fs-md-18" [innerHtml]="medTeam?.bodyText"></p>

                <div embeddedHTML class="mt-3 fs-md-18" *ngIf="pediatric" [innerHtml]="pediatric.bodyText"></div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid pt-3" *ngIf="!isNull">
    <div class="container-xxxl bg-white">
        <div class="row">
            <div class="col">
                <p class="med-team-specialists-title" *ngIf="recommended">{{ recommended.title }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div ngbAccordion class="accordion-diag-med-team" [destroyOnHide]="false">
                    <div *ngFor="let article of articlesDisplayed; let i = index" [ngbAccordionItem]="prefix + '-' + i" #item="ngbAccordionItem" [class.active]="!item.collapsed">
                        <h3 ngbAccordionHeader class="m-0" aria-level="3">
                            <button ngbAccordionButton>
                                {{ article.title }}
                            </button>
                        </h3>

                        <div ngbAccordionCollapse class="d-print-block">
                            <div ngbAccordionBody class="accordion-body bg-lightblue min-h-print-0">
                                <ng-template>
                                    <div class="col-12 clearfix d-lg-flex align-items-start">
                                        <img
                                            class="rounded-3 d-block d-print-none mx-auto mb-3 mb-sm-0 float-sm-start float-lg-none me-sm-3 ms-sm-0 flex-shrink-0"
                                            *ngIf="article.images[0].url"
                                            [src]="articleImagesPath + article.images[0].url + '-250.webp'"
                                            [alt]="article.images[0].altText"
                                        />
                                        <div class="d-inline d-lg-block flex-grow-1 text-link fs-18" embeddedHTML [innerHTML]="article.bodyText"></div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
